import { render } from "./OverviewUser.vue?vue&type=template&id=31469960&scoped=true"
import script from "./OverviewUser.vue?vue&type=script&lang=js"
export * from "./OverviewUser.vue?vue&type=script&lang=js"

import "./OverviewUser.vue?vue&type=style&index=0&id=31469960&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31469960"]])

export default __exports__